module.exports = __webpack_public_path__ + "images/c29741d5.png";